import { Injectable } from '@angular/core';
import {
	Router, Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot
} from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SiteNote } from 'src/app/models/site-notes/site-note.model';
import { SiteNotesService } from 'src/app/services/sections/site-notes/site-notes.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { ResolvedSiteNote } from './models/resolved-site-note.model';

@Injectable({
	providedIn: 'root'
})
export class SiteNoteReadonlyResolver implements Resolve<Observable<ResolvedSiteNote>> {
	constructor(
		private router: Router,
		private siteNotesService: SiteNotesService
	) { }

		resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {
			GlobalSettingsService.isSecondaryLoaderLoading = true;

			return this.siteNotesService.getReadonlySiteNote(activatedRouteSnapshot.paramMap.get('token'))
				.pipe(
					map((siteNote: SiteNote) => ({data: siteNote, hasError: false, errorMsg: null})),
					catchError((error, caught) => {					
						let errorMsg = "Unable to get the site note details. Please try again!";
						if(error.status === 401) {
							errorMsg = "You cannot see this site note using the provided credentials"
						}
						return of({data: null, hasError: true, errorMsg: errorMsg})
					})
				);
		}
}
